import { Button, Center, Paper, Stack, Text, TextInput, Title } from '@mantine/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLogout } from '@/api/session';
import { useCreateWorkspace } from '@/api/workspace';
import { Logo } from '@/components/Logo';
import { useApiError } from '@/hooks/useApiError';

/** Kein aktiver Workspace (z. B. nach Entfernen): neuen anlegen. */
export function NoWorkspace() {
  const { t } = useTranslation();
  const [name, setName] = useState('');
  const create = useCreateWorkspace();
  const logout = useLogout();
  const onError = useApiError();
  return (
    <Center mih="100dvh" p="md">
      <Paper withBorder p="xl" maw={420} w="100%">
        <Stack>
          <Logo />
          <Title order={3}>{t('workspace.noneTitle')}</Title>
          <Text c="dimmed">{t('workspace.noneText')}</Text>
          <TextInput label={t('workspace.name')} value={name} onChange={(e) => setName(e.currentTarget.value)} />
          <Button disabled={!name.trim()} loading={create.isPending} onClick={() => create.mutate(name, { onError })}>
            {t('workspace.create')}
          </Button>
          <Button variant="subtle" onClick={() => logout.mutate()}>
            {t('header.logout')}
          </Button>
        </Stack>
      </Paper>
    </Center>
  );
}
